/**
 * Labstep
 *
 * @module ProtocolTimer/Action/Create
 * @desc ProtocolTimer create action
 */

import EntityActionCreate from 'labstep-web/components/Entity/Action/Create';
import { ProtocolTimer } from 'labstep-web/models/protocol-timer.model';
import type React from 'react';
import type { IProtocolTimerActionCreateProps } from './types';

export const actionText = `Add ${ProtocolTimer.getHumanReadableEntityName(
  false,
  true,
)}`;

export const ProtocolTimerActionCreate: React.FC<
  IProtocolTimerActionCreateProps
> = ({ protocol, actionComponentProps = {} }) => (
  <EntityActionCreate
    entityName={ProtocolTimer.entityName}
    body={{
      name: `Untitled ${ProtocolTimer.getHumanReadableEntityName(
        false,
        true,
      )}`,
    }}
    actionComponentProps={{ type: 'option', text: actionText }}
    parentName={protocol.entityName}
    parentId={protocol.id}
    {...actionComponentProps}
  />
);
